import React from 'react';
import { Navigate } from 'react-router-dom';
import { useAuth } from '../../context/AuthContext';
import Loading from '../Common/Loading';

export default function ProtectedRoute({ children, allowedRoles }) {
  const { user, loading, isAuthenticated } = useAuth();

  if (loading) {
    return <Loading message="Checking authentication..." />;
  }

  if (!isAuthenticated) {
    return <Navigate to="/login" replace />;
  }

  // Check role-based access
  if (allowedRoles && !allowedRoles.includes(user?.role)) {
    return (
      <div style={{
        display: 'flex',
        flexDirection: 'column',
        alignItems: 'center',
        justifyContent: 'center',
        minHeight: '100vh',
        textAlign: 'center',
        padding: '20px'
      }}>
        <h1 style={{ color: '#f44336', fontSize: '48px', margin: '0 0 16px 0' }}>403</h1>
        <h2 style={{ color: '#333', margin: '0 0 8px 0' }}>Access Denied</h2>
        <p style={{ color: '#666', margin: '0' }}>You don't have permission to access this page.</p>
      </div>
    );
  }

  return children;
}
